import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {
    refreshComments,
    refreshCommentsError,
    deleteLastComment,
    deleteLastCommentError,
    sendNotificationForLastComment,
    loadComments
} from '../store/actions/commentsActions';
import './Comments.scss';

import ButtonSpinner from './_common/ButtonSpinner';
import InfoModal from './_common/InfoModal';
import ErrorModal from './_common/ErrorModal';
import {toggleModal} from "../store/actions/toggleModalActions";
import NotificationModal from "./NotificationModal";

const selector = state => {
    const { language, comments, modalState } = state;
    return {
        t: language.translator,
        pending: comments.pending,
        pendingDelete: comments.pendingDelete,
        deleteMessage: comments.deleteMessage,
        error: comments.error,
        modalState: modalState,
        comments: comments.comments,
    };
};

const Comments = () => {
    const { t, pending, pendingDelete, deleteMessage, error, modalState, comments } = useSelector(selector);
    const dispatch = useDispatch();

    const [notificationModal, setNotificationModal] = React.useState(false);
    const [selectedComment, setSelectedComment] = React.useState(null);

    useEffect(() => {
        dispatch(loadComments())
    }, []);

    const handleRefreshCommentsButtonClick = () => {
        dispatch(refreshComments());
    };

    const handleDeleteLastCommentButtonClick = () => {
        dispatch(deleteLastComment());
    };

    const handleSendNotificationForLastCommentButtonClick = () => {
        setSelectedComment(null)
        setNotificationModal(!notificationModal)
    }

    const handleSendNotificationForSpecificCommentClick = (item) => {
        setSelectedComment(null)
        if(item) {
            setSelectedComment(item)
        }
        setNotificationModal(!notificationModal)
    }
    return (
        <div className='page'>
            <div className='pageHeader'>
                <div className='pageHeaderLeft'>
                    <div className='pageHeaderTitle'>
                        {t.gettext('IPSAD comments')}
                    </div>
                </div>
            </div>
            <div className='Comments'>
                <div className='column column100'>
                    <div className='commentsButtonWrapper'>
                        <button
                            className={pending ? 'commentsButton commentsButton--pending' : 'commentsButton'}
                            onClick={handleRefreshCommentsButtonClick}
                        >
                            {pending ? <ButtonSpinner/> : t.gettext('Refresh comments in the app')}
                        </button>
                    </div>
                    <div className='commentsButtonWrapper'>
                        <button
                            className={pending ? 'commentsButton commentsButton--pending' : 'commentsButton'}
                            onClick={handleDeleteLastCommentButtonClick}
                        >
                            {pendingDelete ? <ButtonSpinner/> : t.gettext('Delete last comment in the app')}
                        </button>
                    </div>
                    <div className='commentsButtonWrapper'>
                        <button
                            className={pending ? 'commentsButton commentsButton--pending' : 'commentsButton'}
                            onClick={handleSendNotificationForLastCommentButtonClick}
                        >
                            {t.gettext('Send notification about last comment')}
                        </button>
                    </div>
                </div>
                <div className="scrollableList">
                    {comments.map((item) => (
                        <div key={item.id} className="listItem">
                            <div className="listContent">
                                <div className="listDate">{new Date(item.date).toLocaleString()}</div>
                                <div className="listTitle">{item.title}</div>
                            </div>
                            <button className="btnAddNotification"
                                onClick={() => handleSendNotificationForSpecificCommentClick(item)}
                            >
                                {t.gettext("Add notification")}
                            </button>
                        </div>
                    ))}
                </div>
            </div>

            {modalState.flag && modalState.modal === 'commentsRefreshSuccess' &&
                <InfoModal
                    text={t.gettext('Comments in the app have been refreshed')}
                    closeMethod={() => dispatch(toggleModal(false, ''))}
                />
            }

            {modalState.flag && modalState.modal === 'lastCommentDeleteSuccess' &&
                <InfoModal
                    text={deleteMessage ? deleteMessage : t.gettext('Last comment in the app has been deleted')}
                    closeMethod={() => dispatch(toggleModal(false, ''))}
                />
            }

            {!!error &&
                <ErrorModal
                    error={error}
                    closeMethod={() => {
                      dispatch(refreshCommentsError(''))
                      dispatch(deleteLastCommentError(''))
                    }}
                />
            }
            {notificationModal && (
                <NotificationModal
                    selectedComment={selectedComment}
                    closeMethod={() => setNotificationModal(false)}
                />
            )}
        </div>
    );
};

export default Comments;
